import type { ScaleLinear } from 'd3-scale';

type NormalizeZeroParams = {
  zeroPixel: number;
  minRange: number;
  maxRange: number;
};

export const normalizeZero = ({
  zeroPixel,
  minRange,
  maxRange,
}: NormalizeZeroParams) => {
  if (zeroPixel > minRange) {
    return minRange;
  }
  if (zeroPixel < maxRange) {
    return maxRange;
  }
  return zeroPixel;
};

export const getSafeZero = (yScale: ScaleLinear<number, number>) => {
  const zeroPixel = yScale(0) as number;
  const minRange = yScale.range()[0];
  const maxRange = yScale.range()[1];

  return normalizeZero({ zeroPixel, minRange, maxRange });
};
